
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $9DHhW = parcelRequire("9DHhW");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $8wW9d = parcelRequire("8wW9d");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $lfoFx = parcelRequire("lfoFx");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1mT5xdRAKS",
            __cmplp.isLoading ? "_1UtDYzKGUX" : "_1UtDYzZqHV",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XsHFM4F84 _3138424F84 _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "small",
            interactionName: "forge-content-tools-loading"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
Object.assign($ced39bfea5ef5993$export$9f275aff884e1431, {
    propTypes: {
        extension: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired,
        isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired
    }
});



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $cozmU.useState)(null);
    const [isLoading, setLoading] = (0, $cozmU.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $cozmU.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $cozmU.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $cozmU.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $cozmU.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $cozmU.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            } // Instrument the presence of non-content 3P content-action apps so
            // their keys are folded into the page-load `connectAppKeys` telemetry.
            (0, $8wW9d.recordNonContentAppKeys)('content-tools', extensions.map((ext)=>ext?.id));
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbYbGa",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $bDgLe.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$3d2f468c166bad70 = 'confluence:attachmentAction';
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$3d2f468c166bad70,
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_ATTACHMENT_ACTION"] = $af2b0e533822f413$export$3d2f468c166bad70;
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$1764bc361f317144 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dQS92",
    name: "AttachmentActionForgeApp",
    loader: async ()=>(await (parcelRequire("iCWUr"))).AttachmentActionForgeApp
});

const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("bRAKR"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("3w754"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("1UP9A"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("lzd1U"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("gX7D1"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("eX5rV"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("b1dri"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("iVoUG"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("4XoHD"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("4M7Vo"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("a0kbn"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("auf0K"))).PageBannerForgeApp
});
module.exports["AttachmentActionForgeApp"] = $02976f123c8f8e25$export$1764bc361f317144;
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("iCWUr", function(module, exports) {

let $d8f978c4b524c33a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d8f978c4b524c33a$var$load("hUbK8"),
    $d8f978c4b524c33a$var$load("2RkKX"),
    $d8f978c4b524c33a$var$load("LWh5V"),
    $d8f978c4b524c33a$var$load("eNXrl"),
    $d8f978c4b524c33a$var$load("dZsGY"),
    $d8f978c4b524c33a$var$load("1Gr4q"),
    $d8f978c4b524c33a$var$load("fB5NV"),
    $d8f978c4b524c33a$var$load("ir5Be"),
    $d8f978c4b524c33a$var$load("7SteV"),
    $d8f978c4b524c33a$var$load("7G12e"),
    $d8f978c4b524c33a$var$load("4AElS"),
    $d8f978c4b524c33a$var$load("gjIbu"),
    $d8f978c4b524c33a$var$load("3vH95"),
    $d8f978c4b524c33a$var$load("fnO1K"),
    $d8f978c4b524c33a$var$load("fsIfb"),
    $d8f978c4b524c33a$var$load("aHnaA"),
    $d8f978c4b524c33a$var$load("aLwQm"),
    $d8f978c4b524c33a$var$load("aIWH7"),
    $d8f978c4b524c33a$var$load("5d9j0"),
    $d8f978c4b524c33a$var$load("kkkxt"),
    $d8f978c4b524c33a$var$load("1FRba"),
    $d8f978c4b524c33a$var$load("4x9Jx"),
    $d8f978c4b524c33a$var$load("kHXvF"),
    $d8f978c4b524c33a$var$load("ea3NB"),
    $d8f978c4b524c33a$var$load("59hV4"),
    $d8f978c4b524c33a$var$load("fibpY"),
    $d8f978c4b524c33a$var$load("4O6U4"),
    $d8f978c4b524c33a$var$load("fuOfV"),
    $d8f978c4b524c33a$var$load("jL1Ke"),
    $d8f978c4b524c33a$var$load("5MQ0D"),
    $d8f978c4b524c33a$var$load("cvcNg"),
    $d8f978c4b524c33a$var$load("iZR3N"),
    $d8f978c4b524c33a$var$load("jXM1T"),
    $d8f978c4b524c33a$var$load("6wr18"),
    $d8f978c4b524c33a$var$load("4N1MY"),
    $d8f978c4b524c33a$var$load("ffEVr"),
    $d8f978c4b524c33a$var$load("i7f39"),
    $d8f978c4b524c33a$var$load("hwJJ4"),
    $d8f978c4b524c33a$var$load("iGaRG"),
    $d8f978c4b524c33a$var$load("kJ1vX"),
    $d8f978c4b524c33a$var$load("gpSaW"),
    $d8f978c4b524c33a$var$load("h4Nf7"),
    $d8f978c4b524c33a$var$load("Wowvf"),
    $d8f978c4b524c33a$var$load("lkxmG"),
    $d8f978c4b524c33a$var$load("hESIs"),
    $d8f978c4b524c33a$var$load("9A059"),
    $d8f978c4b524c33a$var$load("Lm7SH"),
    $d8f978c4b524c33a$var$load("hhss7"),
    $d8f978c4b524c33a$var$load("fGNl7"),
    $d8f978c4b524c33a$var$load("lnKog"),
    $d8f978c4b524c33a$var$load("kT6dz"),
    $d8f978c4b524c33a$var$load("aAWLw"),
    $d8f978c4b524c33a$var$load("7EorR"),
    $d8f978c4b524c33a$var$load("fJ8Kj")
]).then(()=>parcelRequire('2L9yO'));

});

parcelRegister("bRAKR", function(module, exports) {

let $8a3127ae07ac70b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8a3127ae07ac70b2$var$load("hUbK8"),
    $8a3127ae07ac70b2$var$load("2RkKX"),
    $8a3127ae07ac70b2$var$load("LWh5V"),
    $8a3127ae07ac70b2$var$load("eNXrl"),
    $8a3127ae07ac70b2$var$load("dZsGY"),
    $8a3127ae07ac70b2$var$load("1Gr4q"),
    $8a3127ae07ac70b2$var$load("fB5NV"),
    $8a3127ae07ac70b2$var$load("ir5Be"),
    $8a3127ae07ac70b2$var$load("7SteV"),
    $8a3127ae07ac70b2$var$load("7G12e"),
    $8a3127ae07ac70b2$var$load("4AElS"),
    $8a3127ae07ac70b2$var$load("gjIbu"),
    $8a3127ae07ac70b2$var$load("3vH95"),
    $8a3127ae07ac70b2$var$load("fnO1K"),
    $8a3127ae07ac70b2$var$load("fsIfb"),
    $8a3127ae07ac70b2$var$load("aHnaA"),
    $8a3127ae07ac70b2$var$load("aLwQm"),
    $8a3127ae07ac70b2$var$load("aIWH7"),
    $8a3127ae07ac70b2$var$load("5d9j0"),
    $8a3127ae07ac70b2$var$load("kkkxt"),
    $8a3127ae07ac70b2$var$load("1FRba"),
    $8a3127ae07ac70b2$var$load("4x9Jx"),
    $8a3127ae07ac70b2$var$load("kHXvF"),
    $8a3127ae07ac70b2$var$load("ea3NB"),
    $8a3127ae07ac70b2$var$load("59hV4"),
    $8a3127ae07ac70b2$var$load("fibpY"),
    $8a3127ae07ac70b2$var$load("4O6U4"),
    $8a3127ae07ac70b2$var$load("fuOfV"),
    $8a3127ae07ac70b2$var$load("jL1Ke"),
    $8a3127ae07ac70b2$var$load("5MQ0D"),
    $8a3127ae07ac70b2$var$load("cvcNg"),
    $8a3127ae07ac70b2$var$load("iZR3N"),
    $8a3127ae07ac70b2$var$load("jXM1T"),
    $8a3127ae07ac70b2$var$load("6wr18"),
    $8a3127ae07ac70b2$var$load("4N1MY"),
    $8a3127ae07ac70b2$var$load("ffEVr"),
    $8a3127ae07ac70b2$var$load("i7f39"),
    $8a3127ae07ac70b2$var$load("hwJJ4"),
    $8a3127ae07ac70b2$var$load("iGaRG"),
    $8a3127ae07ac70b2$var$load("kJ1vX"),
    $8a3127ae07ac70b2$var$load("gpSaW"),
    $8a3127ae07ac70b2$var$load("h4Nf7"),
    $8a3127ae07ac70b2$var$load("Wowvf"),
    $8a3127ae07ac70b2$var$load("lkxmG"),
    $8a3127ae07ac70b2$var$load("hESIs"),
    $8a3127ae07ac70b2$var$load("9A059"),
    $8a3127ae07ac70b2$var$load("Lm7SH"),
    $8a3127ae07ac70b2$var$load("hhss7"),
    $8a3127ae07ac70b2$var$load("fGNl7"),
    $8a3127ae07ac70b2$var$load("lnKog"),
    $8a3127ae07ac70b2$var$load("kT6dz"),
    $8a3127ae07ac70b2$var$load("aAWLw"),
    $8a3127ae07ac70b2$var$load("7EorR"),
    $8a3127ae07ac70b2$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("3w754", function(module, exports) {

let $28f9da59fe2e4e26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $28f9da59fe2e4e26$var$load("hUbK8"),
    $28f9da59fe2e4e26$var$load("2RkKX"),
    $28f9da59fe2e4e26$var$load("LWh5V"),
    $28f9da59fe2e4e26$var$load("eNXrl"),
    $28f9da59fe2e4e26$var$load("dZsGY"),
    $28f9da59fe2e4e26$var$load("1Gr4q"),
    $28f9da59fe2e4e26$var$load("fB5NV"),
    $28f9da59fe2e4e26$var$load("ir5Be"),
    $28f9da59fe2e4e26$var$load("7SteV"),
    $28f9da59fe2e4e26$var$load("7G12e"),
    $28f9da59fe2e4e26$var$load("4AElS"),
    $28f9da59fe2e4e26$var$load("gjIbu"),
    $28f9da59fe2e4e26$var$load("3vH95"),
    $28f9da59fe2e4e26$var$load("fnO1K"),
    $28f9da59fe2e4e26$var$load("fsIfb"),
    $28f9da59fe2e4e26$var$load("aHnaA"),
    $28f9da59fe2e4e26$var$load("aLwQm"),
    $28f9da59fe2e4e26$var$load("aIWH7"),
    $28f9da59fe2e4e26$var$load("5d9j0"),
    $28f9da59fe2e4e26$var$load("kkkxt"),
    $28f9da59fe2e4e26$var$load("1FRba"),
    $28f9da59fe2e4e26$var$load("4x9Jx"),
    $28f9da59fe2e4e26$var$load("kHXvF"),
    $28f9da59fe2e4e26$var$load("ea3NB"),
    $28f9da59fe2e4e26$var$load("59hV4"),
    $28f9da59fe2e4e26$var$load("fibpY"),
    $28f9da59fe2e4e26$var$load("4O6U4"),
    $28f9da59fe2e4e26$var$load("fuOfV"),
    $28f9da59fe2e4e26$var$load("jL1Ke"),
    $28f9da59fe2e4e26$var$load("5MQ0D"),
    $28f9da59fe2e4e26$var$load("cvcNg"),
    $28f9da59fe2e4e26$var$load("iZR3N"),
    $28f9da59fe2e4e26$var$load("jXM1T"),
    $28f9da59fe2e4e26$var$load("6wr18"),
    $28f9da59fe2e4e26$var$load("4N1MY"),
    $28f9da59fe2e4e26$var$load("ffEVr"),
    $28f9da59fe2e4e26$var$load("i7f39"),
    $28f9da59fe2e4e26$var$load("hwJJ4"),
    $28f9da59fe2e4e26$var$load("iGaRG"),
    $28f9da59fe2e4e26$var$load("kJ1vX"),
    $28f9da59fe2e4e26$var$load("gpSaW"),
    $28f9da59fe2e4e26$var$load("h4Nf7"),
    $28f9da59fe2e4e26$var$load("Wowvf"),
    $28f9da59fe2e4e26$var$load("lkxmG"),
    $28f9da59fe2e4e26$var$load("hESIs"),
    $28f9da59fe2e4e26$var$load("9A059"),
    $28f9da59fe2e4e26$var$load("Lm7SH"),
    $28f9da59fe2e4e26$var$load("hhss7"),
    $28f9da59fe2e4e26$var$load("fGNl7"),
    $28f9da59fe2e4e26$var$load("lnKog"),
    $28f9da59fe2e4e26$var$load("kT6dz"),
    $28f9da59fe2e4e26$var$load("aAWLw"),
    $28f9da59fe2e4e26$var$load("7EorR"),
    $28f9da59fe2e4e26$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("1UP9A", function(module, exports) {

let $1652b37a06065e6c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1652b37a06065e6c$var$load("hUbK8"),
    $1652b37a06065e6c$var$load("2RkKX"),
    $1652b37a06065e6c$var$load("LWh5V"),
    $1652b37a06065e6c$var$load("eNXrl"),
    $1652b37a06065e6c$var$load("dZsGY"),
    $1652b37a06065e6c$var$load("1Gr4q"),
    $1652b37a06065e6c$var$load("fB5NV"),
    $1652b37a06065e6c$var$load("ir5Be"),
    $1652b37a06065e6c$var$load("7SteV"),
    $1652b37a06065e6c$var$load("7G12e"),
    $1652b37a06065e6c$var$load("4AElS"),
    $1652b37a06065e6c$var$load("gjIbu"),
    $1652b37a06065e6c$var$load("3vH95"),
    $1652b37a06065e6c$var$load("fnO1K"),
    $1652b37a06065e6c$var$load("fsIfb"),
    $1652b37a06065e6c$var$load("aHnaA"),
    $1652b37a06065e6c$var$load("aLwQm"),
    $1652b37a06065e6c$var$load("aIWH7"),
    $1652b37a06065e6c$var$load("5d9j0"),
    $1652b37a06065e6c$var$load("kkkxt"),
    $1652b37a06065e6c$var$load("1FRba"),
    $1652b37a06065e6c$var$load("4x9Jx"),
    $1652b37a06065e6c$var$load("kHXvF"),
    $1652b37a06065e6c$var$load("ea3NB"),
    $1652b37a06065e6c$var$load("59hV4"),
    $1652b37a06065e6c$var$load("fibpY"),
    $1652b37a06065e6c$var$load("4O6U4"),
    $1652b37a06065e6c$var$load("fuOfV"),
    $1652b37a06065e6c$var$load("jL1Ke"),
    $1652b37a06065e6c$var$load("5MQ0D"),
    $1652b37a06065e6c$var$load("cvcNg"),
    $1652b37a06065e6c$var$load("iZR3N"),
    $1652b37a06065e6c$var$load("jXM1T"),
    $1652b37a06065e6c$var$load("6wr18"),
    $1652b37a06065e6c$var$load("4N1MY"),
    $1652b37a06065e6c$var$load("ffEVr"),
    $1652b37a06065e6c$var$load("i7f39"),
    $1652b37a06065e6c$var$load("hwJJ4"),
    $1652b37a06065e6c$var$load("iGaRG"),
    $1652b37a06065e6c$var$load("kJ1vX"),
    $1652b37a06065e6c$var$load("gpSaW"),
    $1652b37a06065e6c$var$load("h4Nf7"),
    $1652b37a06065e6c$var$load("Wowvf"),
    $1652b37a06065e6c$var$load("lkxmG"),
    $1652b37a06065e6c$var$load("hESIs"),
    $1652b37a06065e6c$var$load("9A059"),
    $1652b37a06065e6c$var$load("Lm7SH"),
    $1652b37a06065e6c$var$load("hhss7"),
    $1652b37a06065e6c$var$load("fGNl7"),
    $1652b37a06065e6c$var$load("lnKog"),
    $1652b37a06065e6c$var$load("kT6dz"),
    $1652b37a06065e6c$var$load("aAWLw"),
    $1652b37a06065e6c$var$load("7EorR"),
    $1652b37a06065e6c$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("lzd1U", function(module, exports) {

let $fb36f952164fcb24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fb36f952164fcb24$var$load("iGaRG"),
    $fb36f952164fcb24$var$load("kJ1vX"),
    $fb36f952164fcb24$var$load("hUbK8"),
    $fb36f952164fcb24$var$load("2RkKX"),
    $fb36f952164fcb24$var$load("1Gr4q"),
    $fb36f952164fcb24$var$load("fB5NV"),
    $fb36f952164fcb24$var$load("ir5Be"),
    $fb36f952164fcb24$var$load("7SteV"),
    $fb36f952164fcb24$var$load("7G12e"),
    $fb36f952164fcb24$var$load("4AElS"),
    $fb36f952164fcb24$var$load("gjIbu"),
    $fb36f952164fcb24$var$load("3vH95"),
    $fb36f952164fcb24$var$load("fnO1K"),
    $fb36f952164fcb24$var$load("fsIfb"),
    $fb36f952164fcb24$var$load("aHnaA"),
    $fb36f952164fcb24$var$load("aLwQm"),
    $fb36f952164fcb24$var$load("aIWH7"),
    $fb36f952164fcb24$var$load("5d9j0"),
    $fb36f952164fcb24$var$load("4x9Jx"),
    $fb36f952164fcb24$var$load("kHXvF"),
    $fb36f952164fcb24$var$load("ea3NB"),
    $fb36f952164fcb24$var$load("fibpY"),
    $fb36f952164fcb24$var$load("4O6U4"),
    $fb36f952164fcb24$var$load("cvcNg"),
    $fb36f952164fcb24$var$load("iZR3N"),
    $fb36f952164fcb24$var$load("jXM1T"),
    $fb36f952164fcb24$var$load("6wr18"),
    $fb36f952164fcb24$var$load("4N1MY"),
    $fb36f952164fcb24$var$load("ffEVr"),
    $fb36f952164fcb24$var$load("i7f39"),
    $fb36f952164fcb24$var$load("hwJJ4"),
    $fb36f952164fcb24$var$load("fGNl7"),
    $fb36f952164fcb24$var$load("gpSaW"),
    $fb36f952164fcb24$var$load("h4Nf7"),
    $fb36f952164fcb24$var$load("Wowvf"),
    $fb36f952164fcb24$var$load("lkxmG"),
    $fb36f952164fcb24$var$load("hESIs"),
    $fb36f952164fcb24$var$load("9A059"),
    $fb36f952164fcb24$var$load("Lm7SH"),
    $fb36f952164fcb24$var$load("hhss7"),
    $fb36f952164fcb24$var$load("kT6dz"),
    $fb36f952164fcb24$var$load("aAWLw"),
    $fb36f952164fcb24$var$load("7EorR"),
    $fb36f952164fcb24$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("gX7D1", function(module, exports) {

let $c57812dc5b7d3820$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c57812dc5b7d3820$var$load("iGaRG"),
    $c57812dc5b7d3820$var$load("kJ1vX"),
    $c57812dc5b7d3820$var$load("hUbK8"),
    $c57812dc5b7d3820$var$load("2RkKX"),
    $c57812dc5b7d3820$var$load("1Gr4q"),
    $c57812dc5b7d3820$var$load("fB5NV"),
    $c57812dc5b7d3820$var$load("ir5Be"),
    $c57812dc5b7d3820$var$load("7SteV"),
    $c57812dc5b7d3820$var$load("7G12e"),
    $c57812dc5b7d3820$var$load("4AElS"),
    $c57812dc5b7d3820$var$load("gjIbu"),
    $c57812dc5b7d3820$var$load("3vH95"),
    $c57812dc5b7d3820$var$load("fnO1K"),
    $c57812dc5b7d3820$var$load("fsIfb"),
    $c57812dc5b7d3820$var$load("aHnaA"),
    $c57812dc5b7d3820$var$load("aLwQm"),
    $c57812dc5b7d3820$var$load("aIWH7"),
    $c57812dc5b7d3820$var$load("5d9j0"),
    $c57812dc5b7d3820$var$load("4x9Jx"),
    $c57812dc5b7d3820$var$load("kHXvF"),
    $c57812dc5b7d3820$var$load("ea3NB"),
    $c57812dc5b7d3820$var$load("fibpY"),
    $c57812dc5b7d3820$var$load("4O6U4"),
    $c57812dc5b7d3820$var$load("cvcNg"),
    $c57812dc5b7d3820$var$load("iZR3N"),
    $c57812dc5b7d3820$var$load("jXM1T"),
    $c57812dc5b7d3820$var$load("6wr18"),
    $c57812dc5b7d3820$var$load("4N1MY"),
    $c57812dc5b7d3820$var$load("ffEVr"),
    $c57812dc5b7d3820$var$load("i7f39"),
    $c57812dc5b7d3820$var$load("hwJJ4"),
    $c57812dc5b7d3820$var$load("fGNl7"),
    $c57812dc5b7d3820$var$load("gpSaW"),
    $c57812dc5b7d3820$var$load("h4Nf7"),
    $c57812dc5b7d3820$var$load("Wowvf"),
    $c57812dc5b7d3820$var$load("lkxmG"),
    $c57812dc5b7d3820$var$load("hESIs"),
    $c57812dc5b7d3820$var$load("9A059"),
    $c57812dc5b7d3820$var$load("Lm7SH"),
    $c57812dc5b7d3820$var$load("hhss7"),
    $c57812dc5b7d3820$var$load("kT6dz"),
    $c57812dc5b7d3820$var$load("aAWLw"),
    $c57812dc5b7d3820$var$load("7EorR"),
    $c57812dc5b7d3820$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("eX5rV", function(module, exports) {

let $ae2acd8615b83585$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ae2acd8615b83585$var$load("iGaRG"),
    $ae2acd8615b83585$var$load("kJ1vX"),
    $ae2acd8615b83585$var$load("hUbK8"),
    $ae2acd8615b83585$var$load("2RkKX"),
    $ae2acd8615b83585$var$load("1Gr4q"),
    $ae2acd8615b83585$var$load("fB5NV"),
    $ae2acd8615b83585$var$load("ir5Be"),
    $ae2acd8615b83585$var$load("7SteV"),
    $ae2acd8615b83585$var$load("7G12e"),
    $ae2acd8615b83585$var$load("4AElS"),
    $ae2acd8615b83585$var$load("gjIbu"),
    $ae2acd8615b83585$var$load("3vH95"),
    $ae2acd8615b83585$var$load("fnO1K"),
    $ae2acd8615b83585$var$load("fsIfb"),
    $ae2acd8615b83585$var$load("aHnaA"),
    $ae2acd8615b83585$var$load("aLwQm"),
    $ae2acd8615b83585$var$load("aIWH7"),
    $ae2acd8615b83585$var$load("5d9j0"),
    $ae2acd8615b83585$var$load("4x9Jx"),
    $ae2acd8615b83585$var$load("kHXvF"),
    $ae2acd8615b83585$var$load("ea3NB"),
    $ae2acd8615b83585$var$load("fibpY"),
    $ae2acd8615b83585$var$load("4O6U4"),
    $ae2acd8615b83585$var$load("cvcNg"),
    $ae2acd8615b83585$var$load("iZR3N"),
    $ae2acd8615b83585$var$load("jXM1T"),
    $ae2acd8615b83585$var$load("6wr18"),
    $ae2acd8615b83585$var$load("4N1MY"),
    $ae2acd8615b83585$var$load("ffEVr"),
    $ae2acd8615b83585$var$load("i7f39"),
    $ae2acd8615b83585$var$load("hwJJ4"),
    $ae2acd8615b83585$var$load("fGNl7"),
    $ae2acd8615b83585$var$load("gpSaW"),
    $ae2acd8615b83585$var$load("h4Nf7"),
    $ae2acd8615b83585$var$load("Wowvf"),
    $ae2acd8615b83585$var$load("lkxmG"),
    $ae2acd8615b83585$var$load("hESIs"),
    $ae2acd8615b83585$var$load("9A059"),
    $ae2acd8615b83585$var$load("Lm7SH"),
    $ae2acd8615b83585$var$load("hhss7"),
    $ae2acd8615b83585$var$load("kT6dz"),
    $ae2acd8615b83585$var$load("aAWLw"),
    $ae2acd8615b83585$var$load("7EorR"),
    $ae2acd8615b83585$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("b1dri", function(module, exports) {

let $805a367b2ba7437a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $805a367b2ba7437a$var$load("iGaRG"),
    $805a367b2ba7437a$var$load("kJ1vX"),
    $805a367b2ba7437a$var$load("hUbK8"),
    $805a367b2ba7437a$var$load("2RkKX"),
    $805a367b2ba7437a$var$load("1Gr4q"),
    $805a367b2ba7437a$var$load("fB5NV"),
    $805a367b2ba7437a$var$load("ir5Be"),
    $805a367b2ba7437a$var$load("7SteV"),
    $805a367b2ba7437a$var$load("7G12e"),
    $805a367b2ba7437a$var$load("4AElS"),
    $805a367b2ba7437a$var$load("gjIbu"),
    $805a367b2ba7437a$var$load("3vH95"),
    $805a367b2ba7437a$var$load("fnO1K"),
    $805a367b2ba7437a$var$load("fsIfb"),
    $805a367b2ba7437a$var$load("aHnaA"),
    $805a367b2ba7437a$var$load("aLwQm"),
    $805a367b2ba7437a$var$load("aIWH7"),
    $805a367b2ba7437a$var$load("5d9j0"),
    $805a367b2ba7437a$var$load("4x9Jx"),
    $805a367b2ba7437a$var$load("kHXvF"),
    $805a367b2ba7437a$var$load("ea3NB"),
    $805a367b2ba7437a$var$load("fibpY"),
    $805a367b2ba7437a$var$load("4O6U4"),
    $805a367b2ba7437a$var$load("cvcNg"),
    $805a367b2ba7437a$var$load("iZR3N"),
    $805a367b2ba7437a$var$load("jXM1T"),
    $805a367b2ba7437a$var$load("6wr18"),
    $805a367b2ba7437a$var$load("4N1MY"),
    $805a367b2ba7437a$var$load("ffEVr"),
    $805a367b2ba7437a$var$load("i7f39"),
    $805a367b2ba7437a$var$load("hwJJ4"),
    $805a367b2ba7437a$var$load("gpSaW"),
    $805a367b2ba7437a$var$load("h4Nf7"),
    $805a367b2ba7437a$var$load("Wowvf"),
    $805a367b2ba7437a$var$load("lkxmG"),
    $805a367b2ba7437a$var$load("hESIs"),
    $805a367b2ba7437a$var$load("9A059"),
    $805a367b2ba7437a$var$load("Lm7SH"),
    $805a367b2ba7437a$var$load("hhss7"),
    $805a367b2ba7437a$var$load("fGNl7"),
    $805a367b2ba7437a$var$load("lnKog"),
    $805a367b2ba7437a$var$load("kT6dz"),
    $805a367b2ba7437a$var$load("aAWLw"),
    $805a367b2ba7437a$var$load("7EorR"),
    $805a367b2ba7437a$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("iVoUG", function(module, exports) {

let $dc70e022b0b78204$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dc70e022b0b78204$var$load("hUbK8"),
    $dc70e022b0b78204$var$load("2RkKX"),
    $dc70e022b0b78204$var$load("dZsGY"),
    $dc70e022b0b78204$var$load("1Gr4q"),
    $dc70e022b0b78204$var$load("fB5NV"),
    $dc70e022b0b78204$var$load("ir5Be"),
    $dc70e022b0b78204$var$load("7SteV"),
    $dc70e022b0b78204$var$load("7G12e"),
    $dc70e022b0b78204$var$load("4AElS"),
    $dc70e022b0b78204$var$load("gjIbu"),
    $dc70e022b0b78204$var$load("3vH95"),
    $dc70e022b0b78204$var$load("fnO1K"),
    $dc70e022b0b78204$var$load("fsIfb"),
    $dc70e022b0b78204$var$load("aHnaA"),
    $dc70e022b0b78204$var$load("aLwQm"),
    $dc70e022b0b78204$var$load("aIWH7"),
    $dc70e022b0b78204$var$load("5d9j0"),
    $dc70e022b0b78204$var$load("kkkxt"),
    $dc70e022b0b78204$var$load("1FRba"),
    $dc70e022b0b78204$var$load("4x9Jx"),
    $dc70e022b0b78204$var$load("kHXvF"),
    $dc70e022b0b78204$var$load("ea3NB"),
    $dc70e022b0b78204$var$load("59hV4"),
    $dc70e022b0b78204$var$load("fibpY"),
    $dc70e022b0b78204$var$load("4O6U4"),
    $dc70e022b0b78204$var$load("fuOfV"),
    $dc70e022b0b78204$var$load("jL1Ke"),
    $dc70e022b0b78204$var$load("5MQ0D"),
    $dc70e022b0b78204$var$load("cvcNg"),
    $dc70e022b0b78204$var$load("iZR3N"),
    $dc70e022b0b78204$var$load("jXM1T"),
    $dc70e022b0b78204$var$load("6wr18"),
    $dc70e022b0b78204$var$load("4N1MY"),
    $dc70e022b0b78204$var$load("ffEVr"),
    $dc70e022b0b78204$var$load("i7f39"),
    $dc70e022b0b78204$var$load("hwJJ4"),
    $dc70e022b0b78204$var$load("iGaRG"),
    $dc70e022b0b78204$var$load("kJ1vX"),
    $dc70e022b0b78204$var$load("gpSaW"),
    $dc70e022b0b78204$var$load("h4Nf7"),
    $dc70e022b0b78204$var$load("Wowvf"),
    $dc70e022b0b78204$var$load("lkxmG"),
    $dc70e022b0b78204$var$load("hESIs"),
    $dc70e022b0b78204$var$load("9A059"),
    $dc70e022b0b78204$var$load("Lm7SH"),
    $dc70e022b0b78204$var$load("hhss7"),
    $dc70e022b0b78204$var$load("fGNl7"),
    $dc70e022b0b78204$var$load("lnKog"),
    $dc70e022b0b78204$var$load("kT6dz"),
    $dc70e022b0b78204$var$load("aAWLw"),
    $dc70e022b0b78204$var$load("7EorR"),
    $dc70e022b0b78204$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("4XoHD", function(module, exports) {

let $39bfd58c13afb10a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $39bfd58c13afb10a$var$load("hUbK8"),
    $39bfd58c13afb10a$var$load("2RkKX"),
    $39bfd58c13afb10a$var$load("dZsGY"),
    $39bfd58c13afb10a$var$load("1Gr4q"),
    $39bfd58c13afb10a$var$load("fB5NV"),
    $39bfd58c13afb10a$var$load("ir5Be"),
    $39bfd58c13afb10a$var$load("7SteV"),
    $39bfd58c13afb10a$var$load("7G12e"),
    $39bfd58c13afb10a$var$load("4AElS"),
    $39bfd58c13afb10a$var$load("gjIbu"),
    $39bfd58c13afb10a$var$load("3vH95"),
    $39bfd58c13afb10a$var$load("fnO1K"),
    $39bfd58c13afb10a$var$load("fsIfb"),
    $39bfd58c13afb10a$var$load("aHnaA"),
    $39bfd58c13afb10a$var$load("aLwQm"),
    $39bfd58c13afb10a$var$load("aIWH7"),
    $39bfd58c13afb10a$var$load("5d9j0"),
    $39bfd58c13afb10a$var$load("kkkxt"),
    $39bfd58c13afb10a$var$load("1FRba"),
    $39bfd58c13afb10a$var$load("4x9Jx"),
    $39bfd58c13afb10a$var$load("kHXvF"),
    $39bfd58c13afb10a$var$load("ea3NB"),
    $39bfd58c13afb10a$var$load("59hV4"),
    $39bfd58c13afb10a$var$load("fibpY"),
    $39bfd58c13afb10a$var$load("4O6U4"),
    $39bfd58c13afb10a$var$load("fuOfV"),
    $39bfd58c13afb10a$var$load("jL1Ke"),
    $39bfd58c13afb10a$var$load("5MQ0D"),
    $39bfd58c13afb10a$var$load("cvcNg"),
    $39bfd58c13afb10a$var$load("iZR3N"),
    $39bfd58c13afb10a$var$load("jXM1T"),
    $39bfd58c13afb10a$var$load("6wr18"),
    $39bfd58c13afb10a$var$load("4N1MY"),
    $39bfd58c13afb10a$var$load("ffEVr"),
    $39bfd58c13afb10a$var$load("i7f39"),
    $39bfd58c13afb10a$var$load("hwJJ4"),
    $39bfd58c13afb10a$var$load("iGaRG"),
    $39bfd58c13afb10a$var$load("kJ1vX"),
    $39bfd58c13afb10a$var$load("gpSaW"),
    $39bfd58c13afb10a$var$load("h4Nf7"),
    $39bfd58c13afb10a$var$load("Wowvf"),
    $39bfd58c13afb10a$var$load("lkxmG"),
    $39bfd58c13afb10a$var$load("hESIs"),
    $39bfd58c13afb10a$var$load("9A059"),
    $39bfd58c13afb10a$var$load("Lm7SH"),
    $39bfd58c13afb10a$var$load("hhss7"),
    $39bfd58c13afb10a$var$load("fGNl7"),
    $39bfd58c13afb10a$var$load("lnKog"),
    $39bfd58c13afb10a$var$load("kT6dz"),
    $39bfd58c13afb10a$var$load("aAWLw"),
    $39bfd58c13afb10a$var$load("7EorR"),
    $39bfd58c13afb10a$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("4M7Vo", function(module, exports) {

let $37a1cac757a3190b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $37a1cac757a3190b$var$load("iGaRG"),
    $37a1cac757a3190b$var$load("kJ1vX"),
    $37a1cac757a3190b$var$load("hUbK8"),
    $37a1cac757a3190b$var$load("2RkKX"),
    $37a1cac757a3190b$var$load("1Gr4q"),
    $37a1cac757a3190b$var$load("fB5NV"),
    $37a1cac757a3190b$var$load("ir5Be"),
    $37a1cac757a3190b$var$load("7SteV"),
    $37a1cac757a3190b$var$load("7G12e"),
    $37a1cac757a3190b$var$load("4AElS"),
    $37a1cac757a3190b$var$load("gjIbu"),
    $37a1cac757a3190b$var$load("3vH95"),
    $37a1cac757a3190b$var$load("fnO1K"),
    $37a1cac757a3190b$var$load("fsIfb"),
    $37a1cac757a3190b$var$load("aHnaA"),
    $37a1cac757a3190b$var$load("aLwQm"),
    $37a1cac757a3190b$var$load("aIWH7"),
    $37a1cac757a3190b$var$load("5d9j0"),
    $37a1cac757a3190b$var$load("4x9Jx"),
    $37a1cac757a3190b$var$load("kHXvF"),
    $37a1cac757a3190b$var$load("ea3NB"),
    $37a1cac757a3190b$var$load("fibpY"),
    $37a1cac757a3190b$var$load("4O6U4"),
    $37a1cac757a3190b$var$load("cvcNg"),
    $37a1cac757a3190b$var$load("iZR3N"),
    $37a1cac757a3190b$var$load("jXM1T"),
    $37a1cac757a3190b$var$load("6wr18"),
    $37a1cac757a3190b$var$load("4N1MY"),
    $37a1cac757a3190b$var$load("ffEVr"),
    $37a1cac757a3190b$var$load("i7f39"),
    $37a1cac757a3190b$var$load("hwJJ4"),
    $37a1cac757a3190b$var$load("fGNl7"),
    $37a1cac757a3190b$var$load("gpSaW"),
    $37a1cac757a3190b$var$load("h4Nf7"),
    $37a1cac757a3190b$var$load("Wowvf"),
    $37a1cac757a3190b$var$load("lkxmG"),
    $37a1cac757a3190b$var$load("hESIs"),
    $37a1cac757a3190b$var$load("9A059"),
    $37a1cac757a3190b$var$load("Lm7SH"),
    $37a1cac757a3190b$var$load("hhss7"),
    $37a1cac757a3190b$var$load("kT6dz"),
    $37a1cac757a3190b$var$load("aAWLw"),
    $37a1cac757a3190b$var$load("7EorR"),
    $37a1cac757a3190b$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("a0kbn", function(module, exports) {

let $74898f452f11cd1d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $74898f452f11cd1d$var$load("iGaRG"),
    $74898f452f11cd1d$var$load("kJ1vX"),
    $74898f452f11cd1d$var$load("hUbK8"),
    $74898f452f11cd1d$var$load("2RkKX"),
    $74898f452f11cd1d$var$load("1Gr4q"),
    $74898f452f11cd1d$var$load("fB5NV"),
    $74898f452f11cd1d$var$load("ir5Be"),
    $74898f452f11cd1d$var$load("7SteV"),
    $74898f452f11cd1d$var$load("7G12e"),
    $74898f452f11cd1d$var$load("4AElS"),
    $74898f452f11cd1d$var$load("gjIbu"),
    $74898f452f11cd1d$var$load("3vH95"),
    $74898f452f11cd1d$var$load("fnO1K"),
    $74898f452f11cd1d$var$load("fsIfb"),
    $74898f452f11cd1d$var$load("aHnaA"),
    $74898f452f11cd1d$var$load("aLwQm"),
    $74898f452f11cd1d$var$load("aIWH7"),
    $74898f452f11cd1d$var$load("5d9j0"),
    $74898f452f11cd1d$var$load("4x9Jx"),
    $74898f452f11cd1d$var$load("kHXvF"),
    $74898f452f11cd1d$var$load("ea3NB"),
    $74898f452f11cd1d$var$load("fibpY"),
    $74898f452f11cd1d$var$load("4O6U4"),
    $74898f452f11cd1d$var$load("cvcNg"),
    $74898f452f11cd1d$var$load("iZR3N"),
    $74898f452f11cd1d$var$load("jXM1T"),
    $74898f452f11cd1d$var$load("6wr18"),
    $74898f452f11cd1d$var$load("4N1MY"),
    $74898f452f11cd1d$var$load("ffEVr"),
    $74898f452f11cd1d$var$load("i7f39"),
    $74898f452f11cd1d$var$load("hwJJ4"),
    $74898f452f11cd1d$var$load("gpSaW"),
    $74898f452f11cd1d$var$load("h4Nf7"),
    $74898f452f11cd1d$var$load("Wowvf"),
    $74898f452f11cd1d$var$load("lkxmG"),
    $74898f452f11cd1d$var$load("hESIs"),
    $74898f452f11cd1d$var$load("9A059"),
    $74898f452f11cd1d$var$load("Lm7SH"),
    $74898f452f11cd1d$var$load("hhss7"),
    $74898f452f11cd1d$var$load("fGNl7"),
    $74898f452f11cd1d$var$load("lnKog"),
    $74898f452f11cd1d$var$load("kT6dz"),
    $74898f452f11cd1d$var$load("aAWLw"),
    $74898f452f11cd1d$var$load("7EorR"),
    $74898f452f11cd1d$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("auf0K", function(module, exports) {

let $7a28599b197df4e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7a28599b197df4e7$var$load("iGaRG"),
    $7a28599b197df4e7$var$load("kJ1vX"),
    $7a28599b197df4e7$var$load("hUbK8"),
    $7a28599b197df4e7$var$load("2RkKX"),
    $7a28599b197df4e7$var$load("1Gr4q"),
    $7a28599b197df4e7$var$load("fB5NV"),
    $7a28599b197df4e7$var$load("ir5Be"),
    $7a28599b197df4e7$var$load("7SteV"),
    $7a28599b197df4e7$var$load("7G12e"),
    $7a28599b197df4e7$var$load("4AElS"),
    $7a28599b197df4e7$var$load("gjIbu"),
    $7a28599b197df4e7$var$load("3vH95"),
    $7a28599b197df4e7$var$load("fnO1K"),
    $7a28599b197df4e7$var$load("fsIfb"),
    $7a28599b197df4e7$var$load("aHnaA"),
    $7a28599b197df4e7$var$load("aLwQm"),
    $7a28599b197df4e7$var$load("aIWH7"),
    $7a28599b197df4e7$var$load("5d9j0"),
    $7a28599b197df4e7$var$load("4x9Jx"),
    $7a28599b197df4e7$var$load("kHXvF"),
    $7a28599b197df4e7$var$load("ea3NB"),
    $7a28599b197df4e7$var$load("fibpY"),
    $7a28599b197df4e7$var$load("4O6U4"),
    $7a28599b197df4e7$var$load("cvcNg"),
    $7a28599b197df4e7$var$load("iZR3N"),
    $7a28599b197df4e7$var$load("jXM1T"),
    $7a28599b197df4e7$var$load("6wr18"),
    $7a28599b197df4e7$var$load("4N1MY"),
    $7a28599b197df4e7$var$load("ffEVr"),
    $7a28599b197df4e7$var$load("i7f39"),
    $7a28599b197df4e7$var$load("hwJJ4"),
    $7a28599b197df4e7$var$load("gpSaW"),
    $7a28599b197df4e7$var$load("h4Nf7"),
    $7a28599b197df4e7$var$load("Wowvf"),
    $7a28599b197df4e7$var$load("lkxmG"),
    $7a28599b197df4e7$var$load("hESIs"),
    $7a28599b197df4e7$var$load("9A059"),
    $7a28599b197df4e7$var$load("Lm7SH"),
    $7a28599b197df4e7$var$load("hhss7"),
    $7a28599b197df4e7$var$load("fGNl7"),
    $7a28599b197df4e7$var$load("lnKog"),
    $7a28599b197df4e7$var$load("eShF9"),
    $7a28599b197df4e7$var$load("kT6dz"),
    $7a28599b197df4e7$var$load("aAWLw"),
    $7a28599b197df4e7$var$load("7EorR"),
    $7a28599b197df4e7$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("8wW9d", function(module, exports) {
/* eslint-disable check-react-ssr-usage/guard-browser-globals -- Client-only instrumentation; non-content 3P apps are fetched and rendered on the client, never SSRed. */ /**
 * Instrumentation for third-party (3P) apps rendered OUTSIDE of page content
 * (e.g. byline, page banner, context menu, content tools, web panels).
 *
 * Unlike content macros/extensions (which are indexed from the ADF document by
 * `ExtrensionIndexProvider`), these apps are fetched client-side via GraphQL
 * hooks (`useWebItemLocation` / `useExtensionList`) and are therefore invisible
 * to the content-based telemetry.
 *
 * Each non-content surface calls `recordNonContentAppKeys` when its apps resolve.
 * The collected keys are stashed on a dedicated window global and later folded
 * into the page-load metric's `connectAppKeys` attribute (React UFO
 * `extra_properties`) by `pageLoadEventPlugin`, so they land in the same RUM
 * dataset as content app keys.
 */ const $eb9f67592b61ef7c$export$8fb2b6127d91a721 = '::';
const $eb9f67592b61ef7c$export$75dfc4b4563b78a5 = (source, appKeys)=>{
    if (typeof window === 'undefined') return;
    const keys = window.__NON_CONTENT_APP_KEYS__ ?? new Set();
    for (const key of appKeys)if (key) keys.add(`${source}${$eb9f67592b61ef7c$export$8fb2b6127d91a721}${key}`);
    window.__NON_CONTENT_APP_KEYS__ = keys;
};
const $eb9f67592b61ef7c$export$40caeb9e96de3450 = ()=>typeof window === 'undefined' ? new Set() : window.__NON_CONTENT_APP_KEYS__ ?? new Set();
const $eb9f67592b61ef7c$export$d36eed915298b207 = ()=>{
    if (typeof window === 'undefined') return;
    window.__NON_CONTENT_APP_KEYS__ = new Set();
};
module.exports["recordNonContentAppKeys"] = $eb9f67592b61ef7c$export$75dfc4b4563b78a5;
module.exports["getNonContentAppKeys"] = $eb9f67592b61ef7c$export$40caeb9e96de3450;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("04qh3"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("04qh3", function(module, exports) {

let $00d4c153bc0a88fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $00d4c153bc0a88fb$var$load("fGNl7"),
    $00d4c153bc0a88fb$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $8s9DV.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $kBr4q.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $kBr4q.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {

var $hBxDy = parcelRequire("hBxDy");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $hBxDy.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $hBxDy.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("hBxDy", function(module, exports) {
var $77348f0599087222$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $77348f0599087222$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $77348f0599087222$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $77348f0599087222$export$beaef1891b3e7ca3;

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $kSwu1 = parcelRequire("kSwu1");


var $6TaGl = parcelRequire("6TaGl");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $kSwu1.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $kSwu1.useIntl)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $cozmU.useState)('auto');
    const dropdownMenuContainerRef = (0, $cozmU.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $hekY6.default)([
            "_2XsHFMuFDC _4ouGXIoWWg",
            isExternalCollaborator && "_2XsHFMdnbC _4ouGXIoWWg"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $cozmU.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$53635c098825d80c = 'system.attachment';
const $0673dc41d4591954$export$b55f44bb0675280a = 'system.attachment.metadata';
const $0673dc41d4591954$export$932fbff4e94f11bd = 'system.attachment.history';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["SYSTEM_ATTACHMENT"] = $0673dc41d4591954$export$53635c098825d80c;
module.exports["SYSTEM_ATTACHMENT_METADATA"] = $0673dc41d4591954$export$b55f44bb0675280a;
module.exports["SYSTEM_ATTACHMENT_HISTORY"] = $0673dc41d4591954$export$932fbff4e94f11bd;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("3QyBm", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $1xpoY.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("dmDX7", function(module, exports) {

var $7NYI2 = parcelRequire("7NYI2");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $4aa29e57813b75ee$var$UsePendingRequestExistsQuery = (0, $7NYI2.default);
const $4aa29e57813b75ee$export$5354a7f39c2c364a = ({ contentId: contentId, preferPreloadedData: preferPreloadedData = false })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = !userId || !cloudId || !contentId || !(0, $6mKj3.expValEquals)('confluence_frontend_existing_access_request_checks', 'cohort', 'experiment');
    const [isLoadingForFirstTime, setIsLoadingForFirstTime] = (0, $cozmU.useState)(!shouldSkip);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($4aa29e57813b75ee$var$UsePendingRequestExistsQuery, {
        variables: {
            cloudId: cloudId,
            accessRequestedAaid: userId ?? '',
            contentId: contentId ?? ''
        },
        skip: shouldSkip,
        fetchPolicy: preferPreloadedData ? 'cache-first' : 'network-only',
        onCompleted: ()=>{
            setIsLoadingForFirstTime(false);
        },
        __callerPackage__: "access-requests"
    });
    // SSR-safe resolution signal, for consumers that render on the server. `true` as soon as the
    // answer is available in the store on the current render — including the server render, when the
    // result was SSR-preloaded and read via `cache-first`. Unlike `isLoadingForFirstTime`, this lets an
    // SSR consumer render the resolved copy directly into the server HTML.
    const isPendingRequestResolvedForSSR = shouldSkip || data !== undefined;
    const pendingRequestExists = Boolean(data?.confluence_pendingRequestExists?.isPendingAccessRequestExists);
    return {
        pendingRequestExists: pendingRequestExists,
        loading: loading,
        error: error,
        isLoadingForFirstTime: isLoadingForFirstTime,
        isPendingRequestResolvedForSSR: isPendingRequestResolvedForSSR
    };
};
module.exports["usePendingRequestExists"] = $4aa29e57813b75ee$export$5354a7f39c2c364a;

});

parcelRegister("7NYI2", function(module, exports) {
/**
 * @generated SignedSource<<4d7ccfc95dff4e3b611db90e9453df55>>
 * @relayHash f8787096f4d42896880d52d9cbd4670c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9
const $3cde78eca68e7b16$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessRequestedAaid"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessRequestedAaid",
                    "variableName": "accessRequestedAaid"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluencePendingAccessRequest",
            "kind": "LinkedField",
            "name": "confluence_pendingRequestExists",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isPendingAccessRequestExists"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f8787096f4d42896880d52d9cbd4670c",
            "id": "ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9",
            "metadata": {},
            "name": "usePendingRequestExistsQuery",
            "operationKind": "query",
            "text": "query usePendingRequestExistsQuery($accessRequestedAaid:String!,$cloudId:ID!,$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid,cloudId:$cloudId,contentId:$contentId){isPendingAccessRequestExists}}"
        }
    };
}();
$3cde78eca68e7b16$var$node.hash = "4d877c3ca505e954e3d6f173f1138ce0";
var $3cde78eca68e7b16$export$2e2bcd8739ae039 = $3cde78eca68e7b16$var$node;
module.exports["default"] = $3cde78eca68e7b16$export$2e2bcd8739ae039;

});

parcelRegister("4Wxqa", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $8fee23c6d49a3667$export$9ded09b22f16a16c = /*#__PURE__*/ (0, $cozmU.createContext)({});
const $8fee23c6d49a3667$export$54e0aee79ff04c1a = ({ children: children, shareButton: shareButton, title: title, banner: banner, bannerHeight: bannerHeight })=>{
    const value = (0, $cozmU.useMemo)(()=>({
            shareButton: shareButton,
            title: title,
            banner: banner,
            bannerHeight: bannerHeight
        }), [
        shareButton,
        title,
        banner,
        bannerHeight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8fee23c6d49a3667$export$9ded09b22f16a16c.Provider, {
        value: value
    }, children);
};
module.exports["AccessLinkHeaderReplacementsContext"] = $8fee23c6d49a3667$export$9ded09b22f16a16c;
module.exports["AccessLinkHeaderReplacementsProvider"] = $8fee23c6d49a3667$export$54e0aee79ff04c1a;

});


//# sourceMappingURL=ForgeContentTools.2e882808.js.map
